<template>
    <div class="list">
        <!-- <div class="consult_null" v-if="!isDownLoading && orderItems.length == 0" @click.stop="goConsult">订单问题咨询</div> -->
        <scroller style="{padding-top:0px;}" :on-refresh="refresh" :on-infinite="infinite" ref="my_scroller" :height="scrollHeight" :isShowDownLoading="isShowDownLoading">
            <div class="first-load" v-if="isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <div v-if="orderItems.length > 0"  :style='"padding-top:" + notice.tipheight + "px"'>
                <div v-for="(item, index) in orderItems" :key="item.SerialNo + item.OrderId + index"  v-if="item.type !== 'date'">                    
                    <orderItem 
                    :iteminfo="item"
                    :position="index" 
                    :actposition="actposition"
                    @closeMore="closeMore"
                    :itemindex="index"
                    class="orderItems"
                    @deleteItem="deleteItem" 
                    @hisTrack="hisTrack"
                    @toggleOverly="toggleOverly">
                    </orderItem>
                </div>
                <div v-else-if="orderItems[index + 1] && orderItems[index + 1].type !== 'date'" class="my-item-date">
                    <div>{{item.content}}</div>
                </div>
            </div>
            <div v-if="!isDownLoading && orderItems.length == 0" class="no-data-show-list">
                <div class="enpty-order" v-if="!requestError && orderItems.length == 0">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <div>
                        <p class="enpty-order-desc">暂无一年前的订单哟~</p>                        
                    </div>                                    
                </div>
                <div v-if="requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>暂无一年前的订单哟~<br />请稍后再试~</p>
                </div>                
            </div>
          
            <div class="load-more" v-else-if="isEnd">
                 <p class="load-more-txt">没有更多内容了哦~ </p>                                  
            </div>
            <div class="consult" v-if="isEnd" @click.stop="goConsult">订单问题咨询</div>  
          
        </scroller>
        <showmodel ref="showModallist"></showmodel>  
        <notice ref="my_notice" v-if='!!notice.content&&notice.isshow' :text="notice.content" :type="notice.tiptype" topP="top:0px;" v-on:marquee='marquee'></notice>      
        <div v-if="overlayShow" class="overlay"></div>
    </div>
</template>

<script>
    const sourceType=2
    const weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    import scroller from '../components/scroller/components/Scroller.vue'
    import {
        getStrFromUrl,
        changeTitle,
        getCookie,
        addCookie
    } from '../util/tool.js'
    import axios from 'axios'
    import {
        order,
        canceldata,
        orderArray
    } from '../util/order.js'
    import orderItem from '../components/hisorderitem.vue'
    import showmodel from '../components/showmodel'
    import notice from '../components/notice'
    import Bus from '../components/bus.js'
    import {
        api,
        devType,
        miniAppVer,
        enterType
    } from './../util/api.js'
    export default {
        name: 'list',
        components: {
            orderItem,
            scroller,
            showmodel,
            notice            
        },
        data() {
            return {
                noThreeMonthOrder:false,
                nodata: '暂未获取到您的历史订单哟~',
                isFirstLoading: true,
                isShowDownLoading: false,
                requestError: false,
                isDownLoading: true,
                getMonthsDes: 'leq',
                page: 0,
                orderItems: [],
                scrollHeight: document.documentElement.clientHeight + '',                
                scrollPosition: '',
                pageFull: 0,
                pageSec: 0,
                isEnd: false,
                isSecNodata: false,
                isreply: false,
                indexHome: 'https://wx.17u.cn/home/index.html',
                name: '',  
                TsDayNow: new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate()).getTime(),              
                pageSetting: {
                   count: 10,
                   time: 60000,
                },
                actposition: '-1',
                notice:{
                    content:"历史订单测试通知",
                    tiptype:0,
                    tipheight:0,
                    isshow:false
                },
                nextKey: void 0,
                hasMore: '1',
                overlayShow: false
            }
        },
        create() {
            //addCookie('WxUser','openid=oOCyauN1lMP21d4ttZGrQVaVA4sc&unionid=ohmdTtz6H-h0kGgzlYMai3z6noYU',1000000)
        },
        mounted() {
            //请求过滤的列表            
            changeTitle('历史订单')
            let wxuser= this.getWxUser() 
            try{
                axios.post(api.HisConfig, Object.assign(wxuser, {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,                                            
                    'enterType': enterType,                    
                    "sourceType":sourceType,  
                })).then(res => {                    
                    if(res.data && res.data.Body) {                                                         
                        this.pageSetting = Object.assign({}, {                            
                        count: res.data.Body.Count,
                        time: res.data.Body.Time
                        })
                        if (res.data.Body.Notice && res.data.Body.Notice.Content){
                            this.notice=Object.assign({},{
                                content:res.data.Body.Notice.Content,
                                tiptype:res.data.Body.Notice.AfficeType,
                                tipheight:0,
                                isshow:true
                            })                                                                                     
                        } 
                    }else{
                        this.pageSetting={count: 10,time: 60000}
                    }
                    this.init();
                }).catch(err => {
                    this.init();
                })
            }catch(e){
                this.init();
            }
           
        },
        watch: {
            
        },
        methods: {
            toggleOverly(val){
                this.overlayShow = val
            },
            spliteWxUser: function(rStr, str) {
                try {
                    let a = rStr.split("&");
                    for (let i in a)
                        if (a[i].indexOf(str + "=") >= 0) {
                            let n = a[i].split("=");
                            if (null != n[1])
                                return n[1]
                        }
                    return ""
                } catch (e) {}
                return ''
            },
            init() {
                this.isFirstLoading = true;
                this.isShowDownLoading = false;
                this.requestError = false;
                this.isDownLoading = false;
                this.noThreeMonthOrder=false;
                this.page = 0;
                this.orderItems = [];
                this.scrollPosition = '';
                this.pageFull = 0;
                this.pageSec = 0;
                this.isEnd = false;
                this.isSecNodata = false;
                this.isreply = false;
                this.nextKey = void 0
                this.hasMore = '1'
                Bus.$emit('hidedialog', {});
                Bus.$emit('hideCanceldialog', {});                 
                if (!this.isreply) {
                    this.getFirstData()
                } else {
                }
                //this.nodata = `暂无${this.name}订单呦，返回上一页看看吧~`
            },
            backTo: function() {
                this.actposition = '-1'
                this.$router.go(-1);               
            },
            refresh: function(done, isShowToast) {                 
                this.actposition = '-1'
                let me = this 
                me.pageFull = 1;
                this.nextKey = void 0
                let requestdata =me.getCommonParam()
                
                axios.post(api.GetHistoryOrderList, requestdata, {
                    timeout: 5000
                }).then((response) => {
                    me.requestError = false;
                    let dataTemp = response.data.Body
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    this.nextKey = dataTemp.NextKey
                    this.hasMore = dataTemp.HasMore

                    if (dataTemp && dataTemp.Data && dataTemp.Data.length && dataTemp.Data.length > 0) {
                        // 先清空旧数据。
                        me.orderItems=[]
                        me.orderItems = this.detailData(dataTemp.Data);
                        setTimeout(() => {
                            if (typeof done === 'function') {
                                done()
                            } else {
                                me.$refs.my_scroller.finishPullToRefresh();
                            }
                        }, 100)
                    } else {
                        me.orderItems = [];
                        if (typeof done === 'function') {
                            done(true)
                        } else {
                            me.$refs.my_scroller.finishPullToRefresh(true);
                        }
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        me.isEnd=true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                    if (!isShowToast) {
                        me.$toast("更新成功", 'center', 1000)
                    }
                }, (reject) => {
                    if (typeof done === 'function') {
                        done(true)
                    } else {
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        me.requestError = true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                    if (!isShowToast) {
                        me.$toast("更新失败，请重试", 'center', 1000)
                    }
                }).catch(function(error) {
                    console.log(error);
                })                
            },
            infinite: function(done) {                                   
                if(this.isFirstLoading)    return         
                
                let me = this;
                
                if (me.orderItems.length == 0) {
                    me.isDownLoading = false;
                } else {
                    me.isDownLoading = true;
                }
                me.pageFull += 1;
                let requestdata =me.getCommonParam()                                       
                axios.post(api.GetHistoryOrderList, requestdata).then((response) => {
                    me.requestError = false;                        
                    let dataTemp = response.data.Body;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    
                    this.nextKey = dataTemp.NextKey
                    this.hasMore = dataTemp.HasMore
                    
                    if (dataTemp && dataTemp.Data && dataTemp.Data.length && dataTemp.Data.length > 0) {
                        me.orderItems = me.orderItems.concat(this.detailData(dataTemp.Data));
                        if(dataTemp.Data.length<me.pageSetting.count){                            
                            me.isEnd = true
                        }
                        if (typeof done === 'function') {
                            done()
                        } else {
                            me.$refs.my_scroller.finishInfinite();
                        }                        
                    } else {                                             
                        me.$refs.my_scroller.finishInfinite(true);  
                        me.isEnd = true
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                    } else {
                        me.isShowDownLoading = true;
                    }                   
                }, (reject) => {
                    this.pageFull -= 1;
                    if (typeof done === 'function') {
                        done(true)
                    } else {
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                    } else {
                        me.isShowDownLoading = true;
                    }
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                }).catch(function(error) {
                })
                
            },
            getFirstData() {                
                let me = this;
                me.isDownLoading = true;
                me.pageFull = 1;
                me.isreply = true;                
                let requestdata = me.getCommonParam()               
                axios.post(api.GetHistoryOrderList, requestdata).then((response) => {                    
                    this.requestError = false;
                    me.isreply = false;
                    let dataTemp = response.data.Body;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }

                    this.nextKey = dataTemp.NextKey
                    this.hasMore = dataTemp.HasMore

                    // debugger
                    if (dataTemp && dataTemp.Data && dataTemp.Data.length && dataTemp.Data.length > 0) {
                        me.orderItems = [...me.orderItems, ...this.detailData(dataTemp.Data)];
                        me.$refs.my_scroller.finishInfinite();
                    } else {                       
                        me.$refs.my_scroller.finishInfinite(true);
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        me.isEnd=true;
                    } else {
                        me.isShowDownLoading = true;
                    }                    
                    let trackv = `^totalcount^${dataTemp.TotalNumber}^`
                    me.hisTrack(trackv)  
                }, (reject) => {
                    me.isreply = false;
                    this.pageFull -= 1;
                    if (me.isFirstLoading) {
                        me.isFirstLoading = false;
                    }
                    if (me.orderItems.length == 0) {
                        me.isShowDownLoading = false;
                        me.isDownLoading = false;
                        this.requestError = true;
                    } else {
                        me.isShowDownLoading = true;
                    }
                }).catch(function(error) {
                })
            },
            //删除的回调
            deleteItem(data) {                
                let serialNo = data.serialNo,
                    orderId = data.orderId,
                    productId = data.productId,
                    marking = serialNo || orderId;
                let list = Object.assign([], this.orderItems)
                let array = [];
                for(let i=0;i<list.length;i++){
                  let item=list[i]
                  if (productId == item.ProductId && (item.SerialNo === marking || item.OrderId === marking)) {
                     // 埋点 前端从内存中删除
                     this.hisTrack(`^订单删除^前端从内存中删除^点击删除的订单${serialNo}-${orderId}^检索到的订单${item.SerialNo}-${item.OrderId}^v2`)
                     // 最后一个,且前一个是date
                     if(i == list.length-1 && list[i-1].type=='date'){
                         // 从前一个开始，两个都删除
                         list.splice(i-1,2)
                         break
                     }
                     //前后都是date
                     if(list[i-1].type=='date'&&list[i+1].type=='date'){
                         // 从前一个开始，两个都删除
                         list.splice(i-1,2)
                         break
                     }
                     // 只需删除自己
                     list.splice(i,1)
                     break
                  }
                }                
                this.orderItems=list
                this.toggleOverly(false)
            },            
            cancelItem(data) {
                this.refresh(null, false);
            },
            transformNum(n) {
                let num = parseInt(n)
                let arr = ["零", "一", '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
                return arr[num]
            },
            
            goConsult() {
                location.href = `https://wx.17u.cn/kefu/#/other?plat=wxordercenter`
                //AppendTrack(category, action, label, `^订单问题咨询^`)
                this.actposition = '-1'
            },
            closeMore(data) {
               this.actposition = data.actposition
            },
            detailData(itemList) {                                                
                if (itemList.length == 0) {
                    return itemList
                }
                // 如果还没有数据，将lastTime置空一下。
                if (this.orderItems.length==0){
                    // 重置记录的上次分组时间。                
                    this.pageSetting.lastTime=""
                }
                let list = [];
                //let nowDate = new Date();
                let datesobj={}
                datesobj.today = this.TsDayNow; //new Date(nowDate.getFullYear() + '/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate()).getTime();
                datesobj.yesterday = datesobj.today - 86400000;
                datesobj.tomorrow = datesobj.today + 86400000;                
                let typeName = '预订日期'                              
                //列表遍历
                itemList.forEach(item => {
                    let detailDate = '';
                    if (item.CreateDate) {                            
                        this.appendClassifyDate(list,typeName,item.CreateDate,datesobj,this.pageSetting)                            
                        list.push(item);
                    } else {
                        list.push(item);
                        return
                    }                    
                })
                return list
            },            
            appendClassifyDate(list,typeName,date,datesobj,pageSetting){                                
                let key=this.getClassifyDate(typeName,date,datesobj)
                if(pageSetting.lastTime!=key){
                    list.push({type: 'date',content:key})
                    pageSetting.lastTime=key
                }
            },
            getClassifyDate(typeName,date,datesobj){                                
                let detailDate = date.substr(0, 19).replace(/\-/igm, '/');
                let detailDataTime=new Date(detailDate)
                let itemTime = detailDataTime.getTime();

                let itemTimeStr =detailDataTime.getFullYear()+'年'+ (detailDataTime.getMonth() + 1) + '月' + detailDataTime.getDate() + '日'
                if (itemTime > datesobj.today && itemTime < datesobj.tomorrow) {
                    return `${typeName + '： ' +itemTimeStr}  今天`
                } 
                if (itemTime > datesobj.yesterday && itemTime < datesobj.today) {
                    return `${typeName + '： ' + itemTimeStr}  昨天`
                } 
                if (itemTime > datesobj.tomorrow && itemTime < datesobj.tomorrow + 86400000){
                    return `${typeName + '： ' + itemTimeStr}  明天`
                }
                return `${typeName + '： ' + itemTimeStr +'  '+ weekday[detailDataTime.getDay()]}`
            },
            getCommonParam(){
                let me=this
                let wxUser= me.getWxUser()
                let trackv = `^show^${me.pageFull}^${me.pageSetting.count}^`
                me.hisTrack(trackv)    
                return Object.assign({ 
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,                    
                    "pagei": me.pageFull,
                    "count": me.pageSetting.count,
                    "orderFilter": 0,                
                    'enterType': enterType,                    
                    "sourceType":sourceType,
                    "nextKey": this.nextKey
                },wxUser)
            },
            getWxUser(){                
                 let wxuser = getCookie('WxUser');
                
                 if(!wxuser){
                     return {}
                 }                 
                 return {
                     openId: this.spliteWxUser(wxuser, 'openid'),
                     unionId: this.spliteWxUser(wxuser, 'unionid')
                 }
            },
            marquee(e) {                                 
                if (e.type === 'INFO') {
                    this.notice.tipheight= e.height||0                
                } else if (e.type === 'CLOSE') {
                    this.notice.isshow=false
                    this.notice.tipheight= 0                
                }    
            },
            hisTrack(data){                
                AppendTrack("my_orders", "history_order", "h5_minapp_my_orders920", data)
            }
        },
    }
</script>

<style scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #333;
    }
    .list {
        text-align: center;
    }
    .orderItems {
        font-size: 0.24rem;
    }
    .enpty-order-desc {
        width: 60%;
        margin: auto;
        line-height: 0.5rem;
    }
    .no-data-show-list {
        width: 100%;
        box-sizing: border-box;
        padding-top: 2.6rem;
        padding: 0 auto;
        font-size: 0.32rem;
        color: #999;
        text-align: center;
    }
    .no-data-show-list img {
        width: 125px;
    }
    .first-load {
        width: 100%;
        margin: 4rem auto 0;
        text-align: center;
    }
    .first-load img {
        width: 0.6rem;
    }
    .toIndexHome {
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        width: 100px;
        display: inline-block;
        background: #fff;
        color: #333;
        text-decoration: none;
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        margin: 20px auto;
    }
    .request-error {
        text-align: center;
        font-size: 0.32rem;
        line-height: 0.5rem;
    }
    .gt-btn {
        background: #fff;
        margin: 0 auto;
        width: 180px;
        height: 30px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        border-radius: 30px;
        font-size: 14px;
        position: relative;
        color: #333;
        box-shadow: 0 0 0 1px rgba(153,153,153,0.3);
    }    
    .consult {
        font-size: 12px;
        color: #00a0ff;
        margin-top: 35px;
    }
    .consult_null {
        font-size: 12px;
        color: #00a0ff;
        position: fixed;
        z-index: 10;
        left: 50%;
        bottom: 40px;
        transform: translateX(-50%);
    }
    .load_more_warp {
        display: flex;
        align-items: center;
        justify-content: center;
    }

.cuttingtext {
    line-height: 0.26rem;
    font-size: 0.26rem;
    color: rgb(170, 170, 170);
    position: relative;
}
.my-item-date {
        background: #c3c8d4;
        border-radius: 0.26rem;
        text-align: left;
        font-size: 0.26rem;
        height: 0.52rem;
        width: fit-content;
        padding: 0 0.35rem;
        margin: 0.4rem 0 0.2rem 0.2rem;
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        color: #fff;
        font-weight: bold;
    }

.load-more {               
    background: url("http://pic5.40017.cn/04/001/68/06/rBTJU12Ae5OAYLFHAAAAbwyiHKs323.png") repeat-x;
    justify-content: space-between;
    background-position: 0% 50%;
    line-height: 12px;
    text-align: center;    
    font-size: 12px;
    color: #999;
    width: 80%;    
    margin: 0 auto;
    margin-top: 20px;
}
.load-more-txt{      
  font-size: 12px;
  padding: 0 18px 0 18px;    
  color: #999;
  background: #EDF0F7; 
  width: 108px;
  margin: 0 auto;
}
.overlay {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
    z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/page/Apphis.vue